<!-- 畜禽养殖场详情 -->
<template>
  <div class="dialog-husbandry">
    <div class="header">
      <div class="title f-size-24 f-col-white08">{{ data.mc || '-' }}</div>
    </div>
    <div class="body">
      <div class="header">
        <div class="title">基础信息:</div>
      </div>
      <div class="content">
        <div class="descriptions-item">
          <span class="key">养殖场名称：</span>
          <span class="value">{{ data.mc || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">公司地址：</span>
          <span class="value">{{ data.dz || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">法人代表：</span>
          <span class="value">{{ data.frdb || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">联系方式：</span>
          <span class="value">{{ data.lxfs || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">饲养情况：</span>
          <span class="value">{{ data.shzt || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">养殖种类：</span>
          <span class="value">{{ data.yzzl }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">存栏量：</span>
          <span class="value">{{ data.sjclgm || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">清粪方式：</span>
          <span class="value">{{ data.qsQsffs || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">通风方式：</span>
          <span class="value">{{ data.qsTffs || '-' }}</span>
        </div>
        <div class="descriptions-item">
          <span class="key">粪便处理工艺：</span>
          <span class="value">{{ data.fbClgy || '-' }}</span>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="btn">视频监控</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs, nextTick, getCurrentInstance, onMounted } from 'vue'
const props = defineProps({
  data: Object,
})
const { data } = toRefs(props)
</script>

<style lang="scss" scoped>
.dialog-husbandry {
  width: 37rem;
  min-width: 37rem;
  .header {
    text-align: left;
    margin-bottom: 2rem;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 3.15rem;
      line-height: 3.15rem;
    }
  }
  .body {
    .header {
      display: flex;
      margin-bottom: 0;
      justify-content: flex-start;
      margin-bottom: 1rem;
      .title {
        color: #fff;
        font-size: 1.4rem;
        height: 1.85rem;
        line-height: 1.85rem;
        margin-right: 1rem;
        &::before {
          content: '';
          border: 0.05rem solid #8ec0ce;
          width: 0.2rem;
          height: 0.8rem;
          box-sizing: border-box;
          margin-right: 0.4rem;
          display: inline-block;
        }
      }
    }
    .content {
      margin-bottom: 2rem;
      .descriptions-item {
        width: 100%;
        line-height: 2.65rem;
        margin-bottom: 1rem;
        display: flex;
        align-items: flex-end;
        text-align: left;
        align-items: baseline;
        &:last-of-type {
          margin-bottom: 1.4rem;
        }
        .key {
          color: #fff;
          min-width: 8.3rem;
          margin-right: 1.9rem;
          text-align: left;
          text-align-last: justify;
        }
      }
    }
  }
  .bottom {
    display: flex;
    justify-content: flex-end;
    .btn {
      width: 6.2rem;
      margin-right: 2rem;
      text-align: center;
      font-size: 1.3rem;
      color: #fff;
      cursor: pointer;
      background: rgba(102, 146, 138, 0.1);
      border: 0.025rem solid #fff;
      box-sizing: border-box;
      border-radius: 0.1rem;
      &:last-of-type {
        margin-right: 0;
      }
    }
  }
}
</style>
